<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Assign Playlist
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container class="scroll-y overflow" style="height: calc(100vh - 65px - 10px - 48px) !important;">
      <div style="border:1px solid rgba(0, 0, 0, 0.12);">
        <v-text-field
          v-model="search"
          label="Search Playlist"
          type="text"
          @change="applyPlaylistSearch"
          append-icon="fa-search"
          class="filter-user"
        ></v-text-field>
        <v-expansion-panels accordion 
          v-model="panel"
          multiple>
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50" class="assigned-user-heading assigned-user-heading2">Playlist Assigned</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                <v-data-table
                  v-model="selectedPlaylists"
                  :headers="headers"
                  v-show="!loading"
                  :items="playlists"
                  show-select
                  item-key="id"
                  class="mb-5 enrol-user-list-tbl"
                >
                  <template v-slot:item.name="{ item }">
                    <span class="ml-2">{{item.name}}</span>
                  </template>
                  <template v-slot:item.published="{ item }">
                    <v-icon v-if="item.published" color="green">fa-check</v-icon>
                    <v-icon v-else color="red">fa-times</v-icon>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <div style="border:1px solid rgba(0, 0, 0, 0.12);">
        <v-expansion-panels accordion 
          v-model="panel2"
          multiple>
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50" class="assigned-user-heading assigned-user-heading2">Playlist Unassigned</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-skeleton-loader v-if="loading2 && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                <v-skeleton-loader v-if="loading2 && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                <v-data-table
                  v-model="unAssignedPlaylists"
                  :headers="headers"
                  v-show="!loading"
                  :items="playlists2"
                  show-select
                  item-key="id"
                  class="mb-5 enrol-user-list-tbl"
                >
                  <template v-slot:item.name="{ item }">
                    <span class="ml-2">{{item.name}}</span>
                  </template>
                  <template v-slot:item.published="{ item }">
                    <v-icon v-if="item.published" color="green">fa-check</v-icon>
                    <v-icon v-else color="red">fa-times</v-icon>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!loading" color="grey300" class="mr-4 cancel-button"  @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" class="ml-2 add-course-button" @click="process">Save Playlists</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import channelAPI from "@/api/channel.js";
import TableThumb from "@/components/admin/course/TableThumb";

export default {
  name: "ChannelModules",
  components: {
    TableThumb
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      headers: [
        { text: "Playlist", value: "name" }
      ],
      playlists: [],
      search: "",
      pagination: {},
      options: {},
      loading: false,
      searchParams: "",
      selected: [],
      playlists2: [],
      selected2: [],
      loading2: false,
      successMessage: "Playlists Successfully enrolled",
      successUnenrollMessage: "Playlists Successfully Un-enrolled.",
      errorMessage:
        "Oops, something went wrong! Please check information is correct.",
      panel: [0,1],
      panel2: [0,1],
      count:0,
      UnenrolledOptions: {},
      unAssignedPlaylists:[],
      selectedPlaylists:[]
    };
  },
  computed: {
    params: function() {
      return '?page=1';
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  mounted() {
    this.getEnrolPlaylists();
    this.getUnEnrollPlaylists();
  },
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },
    getEnrolPlaylists() {
          this.loading = true;
      channelAPI.getEnrolPlaylists(this.params+this.searchParams, this.id).then(response => {
        this.loading = false;
        this.playlists = response.data.data;
        // this.serverItemsLength = response.data.meta.pagination.total;
      });
    },
    getUnEnrollPlaylists() {
      this.loading2 = true;
      channelAPI.getUnEnrolPlaylists(this.params+this.searchParams, this.id).then(response => {
        this.loading2 = false;
        this.playlists2 = response.data.data;
        // this.serverItemsLength2 = response.data.meta.pagination.total;
      });
    },
    applyPlaylistSearch() {
      if (this.search != null) {
        this.searchParams =
          this.params +
          "&search=name:" +
          this.search;
      } else {
        this.searchParams = this.params;
      }
      this.getEnrolPlaylists();
      this.getUnEnrollPlaylists();
    },
    processEnrolCourses(toast='') {
        this.$snotify.remove(toast.id);
        this.loading = true;
        if (this.selectedCourseCount=== 0) {
            this.$snotify.error(this.nothingSelected);
        } else {
            this.process();
        }
    },
     process() {
      this.loading = true;
      channelAPI
      .enrolPlaylists(this.id, {
          assign_playlists: this.processSelectedPlaylists(),
          unassign_playlists: this.processUnassignSelectedPlaylists()
      })
      .then(() => {
          // EventBus.$emit("CHANNEL_UPDATED", this.params);
          this.closePanel();
          if(this.processSelectedPlaylists().length>0 && this.processUnassignSelectedPlaylists().length>0) {
              this.$snotify.success(this.successMessage);
          }
          else if(this.processSelectedPlaylists().length>0 && this.processUnassignSelectedPlaylists().length<=0) {
              this.$snotify.success(this.successUnenrollMessage);
          }
          else if(this.processSelectedPlaylists().length<=0 && this.processUnassignSelectedPlaylists().length>=0) {
              this.$snotify.success(this.successMessage);
          }
          else {
              this.$snotify.success(this.successMessage);
          }
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      })
      .catch(() => {
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      });
    },
    processSelectedPlaylists() {
        let playlists = [];
        this.selectedPlaylists.forEach(function(x) {
            playlists.push(x.id);
        });
        return playlists;
    },
    processUnassignSelectedPlaylists() {
        let playlists = [];
        this.unAssignedPlaylists.forEach(function(x) {
            playlists.push(x.id);
        });
      return playlists;
    },
  }
};
</script>
